import { toPublicURL } from '@plone/volto/helpers';
import { extractDescription } from './utils';

const Article = (content) => {
  const jsonObj = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': toPublicURL(content['@id']),
    },
    name: content.title,
    headline: content.title,
    image: [],
    datePublished: content.created,
    dateModified: content.modified,
    publisher: {
      '@type': 'Organization',
      name: 'Universität Koblenz',
      url: 'https://www.uni-koblenz.de',
      logo: 'https://www.uni-koblenz.de/Service/medien/logode.svg',
    },
  };
  const descr =
    content.description?.length > 0
      ? content.description
      : extractDescription(content);
  jsonObj.abstract = descr;
  jsonObj.description = descr;

  if (content.image?.download) {
    jsonObj.image.push(toPublicURL(content.image.download));
  }
  if (content.image?.scales) {
    for (const scale in content.image.scales) {
      jsonObj.image.push(toPublicURL(content.image.scales[scale].download));
    }
  }
  if (content.creators?.length > 0) {
    jsonObj.author = {
      '@type': 'Person',
      email: content.creators[0],
    };
  }

  return jsonObj;
};

export default Article;
